import service from "./service"

const companiesQuery = async () => {
    return service()
}

export default companiesQuery